import { render, staticRenderFns } from "./CustomSectionHeader.vue?vue&type=template&id=014f51ec&scoped=true&"
import script from "./CustomSectionHeader.vue?vue&type=script&lang=ts&"
export * from "./CustomSectionHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CustomSectionHeader.vue?vue&type=style&index=0&id=014f51ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014f51ec",
  null
  
)

export default component.exports